import { useCallback } from 'react';
import { getCampaignId, getToken } from '../api/client.js';

/**
 * Hook for sending after-delivery SMS.
 * @param {{ showToast: (msg: string, type?: string) => void }} opts
 * @returns {{ sendAfterDeliverySms: (stopId: string) => Promise<void> }}
 */
export default function useAfterDeliverySms({ showToast }) {
  const sendAfterDeliverySms = useCallback(async (stopId) => {
    if (!stopId) return;
    const campaignId = getCampaignId();
    try {
      const res = await fetch(`/api/c/${campaignId}/sms/after-delivery/${stopId}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${getToken()}`,
          'X-Campaign-Id': campaignId,
        },
      });
      if (res.ok) {
        showToast('SMS envoye au client');
      } else {
        const data = await res.json().catch(() => ({}));
        showToast(data.error || 'SMS echec', 'error');
      }
    } catch (_smsErr) {
      showToast('SMS echec (erreur reseau)', 'error');
    }
  }, [showToast]);

  return { sendAfterDeliverySms };
}
